import { AppUI } from '@seedlang/state';

const SeedlangOnly = ({ children }) => {
  if (!AppUI.siteIsDefault) {
    return null;
  }

  return children;
};

export default SeedlangOnly;